import { useEffect, useState } from 'react'
import { useQuery } from "@tanstack/react-query"

import { history } from 'services/history.js'
import { showLoading } from 'services/util'
import { formatMoneyCents } from 'services/util'
import { getLoggedInUser } from "redux/selectors"

import { getAuctionByCode } from '../api'
import { urlQueryParser } from 'services/util'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/checkout.module.scss'
import cardCss from '../user/sass/mypages.module.scss'

import { useSelector } from "react-redux"
import { getAuctionUser } from '../redux/selectors'
import CheckoutItem from './CheckoutItem'
import CheckoutHeader from './CheckoutHeader'
import CheckoutAddress from './CheckoutAddress'
import CheckoutFixedItem from './CheckoutFixedItem'

import AmEx from '../components/images/payment-cards/american-express.svg'
import Discover from '../components/images/payment-cards/discover.svg'
import Mastercard from '../components/images/payment-cards/mastercard.svg'
import Visa from '../components/images/payment-cards/visa.svg'
import { calculateUserBalance, userItemPaidStatus } from '../util/endedAuctionUtils'
import { calculatePurchaseAmount } from '../items/utils'

const ccTypes = {
  'Visa': { cardImage: Visa, cardAltText: 'Visa logo'},
  'MasterCard': { cardImage: Mastercard, cardAltText: 'Mastercard logo'},
  'Discover': { cardImage: Discover, cardAltText: 'Discover logo'},
  'American Express': { cardImage: AmEx, cardAltText: 'American Express logo'},
}

export default function CheckoutAuction(props) {
  //destructuring auction code from url
  //called id in url query for that convention, but using auction code in aws to declutter url from being massive from aws UUID for auction ID to link tables
  const { auctionId: auctionCode } = urlQueryParser(props.location.search)

  const [myItems, setMyItems] = useState()
  const [myFixedItems, setMyFixedItems] = useState()
  const [myDonations, setMyDonations] = useState()
  const [myTotal, setMyTotal] = useState()
  const [userAddress, setUserAddress] = useState(props.location?.state?.address || {})
  const [isValidAddress, setIsValidAddress] = useState(false)

  const auctionUser = useSelector(getAuctionUser)
  const loggedInUser = useSelector(getLoggedInUser)

  const [lastFour, setLastFour] = useState()

  // load auction data by code, so it will work for deep-linking
  const { data: auctionDetail, error, isLoading } = useQuery({
    queryKey: ["auctionDetail", auctionCode],
    queryFn: async () => {
      return await getAuctionByCode(auctionCode)
    },
    staleTime: 0
  })
  // use effect for query results
  useEffect(() => {
    showLoading(isLoading)

    if (error || (auctionDetail && auctionDetail.error)) {
      console.log('Error!', error || auctionDetail.error)
    }

  }, [auctionDetail, error, isLoading])

  useEffect(() => {

    const allOwedDetails = userItemPaidStatus(auctionUser, auctionDetail)

    setMyItems(allOwedDetails?.unpaid?.filter(ele => ele.ItemId))
    setMyFixedItems(allOwedDetails?.unpaid?.filter(ele => ele.FixedItemId))
    //assign the donation to the first element because userItemPaidStatus should take only donation total
    setMyDonations(allOwedDetails?.unpaid?.filter(ele => ele.Donation)[0])

    const allOwedAmounts = calculateUserBalance(auctionUser, auctionDetail)

    setMyTotal(formatMoneyCents(allOwedAmounts?.total))

  }, [auctionUser, auctionDetail])

  console.log(myDonations)

  useEffect(() => {
    if (auctionUser?.PaymentMethods?.length > 0) {
      setLastFour(auctionUser.PaymentMethods[0].Last4)
    } else {
      setLastFour(undefined)
    }
  }, [auctionUser])

  useEffect(() => {

    // for international addresses, all state and postal code is in the city field
    if (userAddress.country !== 'United States') {
      setIsValidAddress(userAddress.streetAddress1 && userAddress.intlCity)
    }
    else {
      setIsValidAddress(userAddress.streetAddress1 && userAddress.city && userAddress.state && userAddress.zipCode)
    }
  }, [userAddress])

  const redirectPath = () => {
    const historyObj = {
      pathname: '/checkoutconfirm',
      search: `?auctionId=${auctionDetail.AuctionCode}`,
      state: {}
    }

    if (missingAddress())
      historyObj.state.address = userAddress

    return historyObj
  }
  
  const missingAddress = () => {
    return (!auctionUser.CrmId
            || (!loggedInUser.crmUser?.profile?.homeAddress && !loggedInUser.crmUser?.profile?.businessAddress))
  }

  const updateAddress = (address) => {
    console.log({address})
    setUserAddress(address)
  }

  if (!auctionDetail) return (<></>)
  
  return (
    <div className={css['checkout-container']}>

      <CheckoutHeader auctionCode={auctionDetail.AuctionCode} />
        
      {myItems && myItems.length > 0 && 
        <>
          <div className={css['checkout-textline-medium']}>
            <h5>Items Won</h5>
            <p>{`${myItems.length} item${myItems.length === 1 ? '' : 's'}`}</p>
          </div>

          {myItems.map((item) => <CheckoutItem item={item} auction={auctionDetail} />)}
          
          <div className={css['checkout-linebreak']}></div>

        </>
      }


      {myFixedItems && myFixedItems.length > 0 && 
        <>
          <div className={css['checkout-textline-medium']}>
            <h5>Buy Now Items</h5>
          </div>
          {myFixedItems.map((item) => <CheckoutFixedItem item={item} auction={auctionDetail} />)}
          
          <div className={css['checkout-linebreak']}></div>
        </>
      }


      {myDonations?.Donation > 0 && 
        <>
          <div className={css['checkout-textline-medium']}>
            <h5>Donation</h5>
            <p className={css['checkout-item-price']}>${formatMoneyCents(myDonations?.Donation)}</p>
          </div>
          
          <div className={css['checkout-linebreak']}></div>
        </>
      }


      <div className={css['checkout-textline-medium']}>
        <h5>Total</h5>
        <p className={css['checkout-total']}>{`$${myTotal}`}</p>
      </div>

      <div className={css['checkout-linebreak']}></div>

      {lastFour && <div className={css[`checkout-payment`]}>
        <h5>Payment Method</h5>
        
        <div className={css[`checkout-payment-method`]}>
          <img src={ccTypes[auctionUser.PaymentMethods[0].CardType].cardImage}  alt={ccTypes[auctionUser.PaymentMethods[0].CardType].cardAlt} 
            className={cardCss['mypaymentmethods-image']}/>
          <h6>•••{lastFour}</h6>
        </div>

        <button className={css['checkout-payment-different']}
          onClick ={(e) => {history.push({
            pathname: '/paymentupdate/checkout',
            search: `?auctionId=${auctionDetail.AuctionCode}`,
            state: {address: userAddress}
          })}}
          >Enter Different Credit Card</button>
      </div>}

      {!lastFour && <div className={css[`checkout-payment`]}>
        <h5>No payment method is on file</h5>
        <h6>Follow below link to add a payment method.</h6>
        <button className={css['checkout-payment-different']}
          onClick ={(e) => {history.push({
            pathname: '/paymentupdate/checkout',
            search: `?auctionId=${auctionDetail.AuctionCode}`,
            state: {address: userAddress}
          })}}
          >Enter Credit Card</button>
      </div>}

      {lastFour && <div className={css['checkout-linebreak']}></div>}

      {missingAddress() &&
        <CheckoutAddress address={userAddress} updateAddress={updateAddress}/>}

      <p>
        To set up alternate payment methods besides using a credit card, you must contact the auction manager to process the alternate payment(s).
      </p>
      <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${css['checkout-paybutton']}`}
          disabled={!lastFour || (missingAddress() && !isValidAddress)}
          onClick ={(e) => {history.push(redirectPath())}}
          >
        {`Pay $${myTotal}`}
      </button>

    </div>
  )
}